import { Navigate, RouterProvider, createBrowserRouter, useRouteError } from 'react-router-dom'
import { Button } from 'antd'
import { routes } from './routes'
import { AuthLayout, MainLayout, SharedLayout } from '../layouts'

const RootError = () => {
  const error = useRouteError()

  console.error('RootError', error)

  return (
    <div>
      <h1>Something bad happened!</h1>

      <div>
        This is likely due to an application update. Please refresh the page.
        <Button
          type="primary"
          onClick={() => {
            localStorage.clear()
            window.location.reload()
          }}
        >
          Refresh
        </Button>
      </div>

      <div>If the problem persists, please contact the administrator and share the following error message:</div>

      <div>Name: {error.name}</div>
      <div>Message: {error.message}</div>
      <div>Cause: {error.cause}</div>
      <div>Stringify: {error.toString()}</div>
    </div>
  )
}

const Router = () => {
  const router = createBrowserRouter([
    {
      path: '/',
      errorElement: <RootError />,
      element: <SharedLayout />,
      children: [
        {
          index: true,
          element: <Navigate to="dashboard" replace />,
        },
        {
          element: <MainLayout />,
          children: [
            ...routes,
            {
              path: '*',
              async lazy() {
                const Comp = await import('../pages/404')
                return { Component: Comp.default }
              },
            },
          ],
        },
        {
          path: 'auth',
          element: <AuthLayout />,
          children: [
            {
              index: true,
              element: <Navigate to="login" replace />,
            },
            {
              path: 'login',
              async lazy() {
                const Comp = await import('../pages/login')
                return { Component: Comp.default }
              },
            },
          ],
        },
        {
          path: '*',
          async lazy() {
            const Comp = await import('../pages/404')
            return { Component: Comp.default }
          },
        },
      ],
    },
  ])

  return <RouterProvider router={router} />
}

export default Router
